// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light[data-v-418ca081] {\n  color: gray;\n  font-weight: 300;\n}\n.image-preview[data-v-418ca081] {\n  padding: 12px;\n  min-height: 200px;\n  background-color: #eaeaea;\n}\n.image-preview[data-v-418ca081],\ninput[type=file][data-v-418ca081] {\n  min-width: 360px;\n}\n@media (max-width: 1280px) {\n.image-preview[data-v-418ca081],\ninput[type=file][data-v-418ca081] {\n    min-width: 280px;\n}\n}", ""]);
// Exports
module.exports = exports;
